/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tts_CharactersInputs */

const en_tts_characters = /** @type {(inputs: Tts_CharactersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text-to-Speech Characters`)
};

const fr_tts_characters = /** @type {(inputs: Tts_CharactersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caractères synthèse vocale`)
};

const de_tts_characters = /** @type {(inputs: Tts_CharactersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text-to-Speech-Zeichen`)
};

const it_tts_characters = /** @type {(inputs: Tts_CharactersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caratteri di sintesi vocale`)
};

const ru_tts_characters = /** @type {(inputs: Tts_CharactersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Символы, преобразуемые в речь`)
};

const es_tts_characters = /** @type {(inputs: Tts_CharactersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caracteres de texto a voz`)
};

const zh_cn2_tts_characters = /** @type {(inputs: Tts_CharactersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文本转语音字符`)
};

const ja_tts_characters = /** @type {(inputs: Tts_CharactersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音声合成文字`)
};

const hi_tts_characters = /** @type {(inputs: Tts_CharactersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टेक्स्ट-टू-स्पीच कैरेक्टर`)
};

const pt_pt2_tts_characters = /** @type {(inputs: Tts_CharactersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caracteres de texto para fala`)
};

/**
* | output |
* | --- |
* | "Text-to-Speech Characters" |
*
* @param {Tts_CharactersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tts_characters = /** @type {((inputs?: Tts_CharactersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tts_CharactersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_tts_characters(inputs)
	if (locale === "de") return de_tts_characters(inputs)
	if (locale === "it") return it_tts_characters(inputs)
	if (locale === "ru") return ru_tts_characters(inputs)
	if (locale === "es") return es_tts_characters(inputs)
	if (locale === "zh-CN") return zh_cn2_tts_characters(inputs)
	if (locale === "ja") return ja_tts_characters(inputs)
	if (locale === "hi") return hi_tts_characters(inputs)
	if (locale === "pt-PT") return pt_pt2_tts_characters(inputs)
	return en_tts_characters(inputs)
});